export type InstancePlatform = "android" | "ios" | "xcode" | "gradle";

// Instance TID prefixes are the console-wide platform discriminator. Note
// xcode's prefix is sandbox_ (its CR group predates the product name) and
// android is the prefixless fallback.
export function platformFromInstanceId(instanceId: string): InstancePlatform {
	if (instanceId.startsWith("ios_")) return "ios";
	if (instanceId.startsWith("sandbox_")) return "xcode";
	if (instanceId.startsWith("gradle_")) return "gradle";
	return "android";
}
